import type { Result } from '@miyuki/types';

export function ok<TValue>(value: TValue): Result<TValue, never> {
  return { ok: true, value };
}

export function err<TError>(error: TError): Result<never, TError> {
  return { ok: false, error };
}

/** Desempaqueta un `Result` lanzando el error si la operación falló. */
export function unwrap<TValue, TError>(result: Result<TValue, TError>): TValue {
  if (result.ok) return result.value;
  throw result.error instanceof Error ? result.error : new Error(String(result.error));
}

/** Aplica `fn` al valor exitoso, propagando el error sin cambios. */
export function map<TValue, TNext, TError>(
  result: Result<TValue, TError>,
  fn: (value: TValue) => TNext,
): Result<TNext, TError> {
  return result.ok ? ok(fn(result.value)) : result;
}
